import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { UtiltiyProvider } from '../../providers/utiltiy/utiltiy';
import { LoginPage } from '../login/login';


@IonicPage()
@Component({
  selector: 'page-dashboard',
  templateUrl: 'dashboard.html',
})
export class DashboardPage {

  constructor(public navCtrl: NavController, public navParams: NavParams,public utiltiy:UtiltiyProvider) {
  }

  ionViewDidLoad() {
  }



}



// WEBPACK FOOTER //
// ./src/pages/dashboard/dashboard.ts